import {gql, useLazyQuery} from '@apollo/client';

import {AVAILABLE_FEES_FRAGMENT} from '../../../graphql/fragments';
import {
  GetAvailableFees,
  GetAvailableFeesVariables,
} from '../../../schema-types/GetAvailableFees';

export const useBuilderAvailableFees = () => {
  const [getAvailableFees, {data, loading: feesLoading}] = useLazyQuery<
    GetAvailableFees,
    GetAvailableFeesVariables
  >(
    gql`
      query BuilderGetAvailableFees(
        $productId: UUID!
        $accountId: UUID!
        $providerId: UUID!
        $mandateId: UUID
        $hasSubplan: Boolean!
        $parentProductId: UUID
      ) {
        availableFeeComponents(
          accountId: $accountId
          productId: $productId
          providerId: $providerId
          mandateId: $mandateId
          hasSubplan: $hasSubplan
          parentProductId: $parentProductId
        ) {
          fpFees {
            ...AvailableFeeFragment
          }
          dfmFees {
            ...AvailableFeeFragment
          }
          productFees {
            ...AvailableFeeFragment
          }
        }
        planFees(accountId: $accountId) {
          fpFees {
            ...AvailableFeeFragment
          }
          dfmFees {
            ...AvailableFeeFragment
          }
          productFees {
            ...AvailableFeeFragment
          }
        }
        feeComponents(
          productId: $productId
          providerId: $providerId
          parentProductId: $parentProductId
        ) {
          fpFees {
            ...AvailableFeeFragment
          }
          dfmFees {
            ...AvailableFeeFragment
          }
          productFees {
            ...AvailableFeeFragment
          }
        }
      }
      ${AVAILABLE_FEES_FRAGMENT}
    `,
    {
      fetchPolicy: 'network-only',
      nextFetchPolicy: 'network-only',
    }
  );

  return {
    getAvailableFees,
    feesLoading,
    data,
  };
};
